import { PropsWithChildren } from 'react';

import { ArrowDownIcon, ArrowUpIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

type Props = { direction: 'up' | 'down'; onClick: () => void };

export const ScrollPill = ({ direction, onClick, children }: PropsWithChildren<Props>) => {
  const Icon = direction === 'up' ? ArrowUpIcon : ArrowDownIcon;

  return (
    <button
      onClick={onClick}
      className={cn(
        'group/pill absolute left-1/2 z-10 flex min-w-16 -translate-x-1/2 items-center justify-center gap-1 rounded-full border border-border bg-background px-2 py-1 text-sm leading-6 font-medium text-foreground shadow-md transition',
        'hover:border-selected hover:bg-selected-soft hover:text-foreground',
        direction === 'up' ? 'top-3' : 'bottom-3'
      )}
    >
      <Icon size={16} className="shrink-0 text-muted-foreground group-hover/pill:text-primary" />
      {children}
    </button>
  );
};
